module.exports = __webpack_public_path__ + "img/isvIntroductionDevelopment.10f60500.png";